/**
 * @module Shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import {
  Directive,
  Renderer2,
  Input,
  ElementRef,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

/**
 * Directive to set the autofocus to the input field
 */
@Directive({
  selector: '[tmoAutoFocus]',
})
export class AutoFocusDirective implements OnInit, OnChanges {
  /**
   * Input to set autofocus true/false
   */
  @Input() public autoFocus: boolean;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    this.autoFocus = false;
  }

  /*
   *  ngOnInit will be called at the initaialization of directive and set transform value
   */
  public ngOnInit(): void {
    // @TODO will remove the timeout once we get a solution to load the directive after
    // To run the directive after the DOM has finished rendering. Please find the link for more info
    // https://blog.brunoscopelliti.com/run-a-directive-after-the-dom-has-finished-rendering/
  }

  /**
   * Detects the change of Input value: autoFocus
   * @param changes
   */
  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.autoFocus.previousValue !== changes.autoFocus.currentValue) {
      const timeOut = 0;
      if (this.autoFocus) {
        setTimeout(() => {
          this.renderer.selectRootElement(this.el.nativeElement).focus();
        }, timeOut);
      }
    }
  }
}
